var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReports(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.25 20.1406H13.75M8.25 20.1406V15.5573M8.25 20.1406H3.3C3.15413 20.1406 3.01424 20.0827 2.91109 19.9795C2.80795 19.8764 2.75 19.7365 2.75 19.5906V16.1073C2.75 15.9614 2.80795 15.8215 2.91109 15.7184C3.01424 15.6152 3.15413 15.5573 3.3 15.5573H8.25M13.75 20.1406V9.14063M13.75 20.1406H18.7C18.8459 20.1406 18.9858 20.0827 19.0889 19.9795C19.1921 19.8764 19.25 19.7365 19.25 19.5906V4.19062C19.25 4.04476 19.1921 3.90486 19.0889 3.80172C18.9858 3.69857 18.8459 3.64062 18.7 3.64062H14.3C14.1541 3.64062 14.0142 3.69857 13.9111 3.80172C13.8079 3.90486 13.75 4.04476 13.75 4.19062V9.14063M8.25 15.5573V9.69063C8.25 9.54476 8.30795 9.40486 8.41109 9.30172C8.51424 9.19857 8.65413 9.14063 8.8 9.14063H13.75",
    stroke: "#251169",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReports);
export default __webpack_public_path__ + "static/media/reports.994edb128fb409055c39414137797ebb.svg";
export { ForwardRef as ReactComponent };